package utils

object Constants {
    const val VERSION = "0.1.1"
}
